/**
 * Tenant-scoped option sets. The retired boolean feature flags that used to
 * live here (all permanently on) were removed in Sept 2026.
 */

/**
 * "CI" trip type visibility.
 *
 * CI (Continuous Integration) trips are internal test trips, so the option is
 * only offered on non-production tenants. Enabled on Pre-Production and
 * Staging; Production and Dev do not show it.
 */
export const CI_TRIP_TYPE_TENANTS = ["pre-prod", "staging"] as const;

/** Single source of truth for where the "CI" trip type option is offered. */
export function isCiTripTypeTenant(slug: string | null | undefined): boolean {
  return CI_TRIP_TYPE_TENANTS.includes(slug as typeof CI_TRIP_TYPE_TENANTS[number]);
}

/** Trip type options for the active tenant. */
export function tripTypeOptionsForTenant(slug: string | null | undefined): string[] {
  return isCiTripTypeTenant(slug)
    ? ["NVO", "SVO", "Manual", "CI"]
    : ["NVO", "SVO", "Manual"];
}
